import React from "react";

function formatNumber(_num) {
  let num = Number(_num);
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num.toString();
}

const ShowCount = ({ count }) => {
  const formattedCount = formatNumber(count);
  return (
    <sup data-show="true" className="ant-scroll-number ant-badge-count" title={count}>{count > 0 ? formattedCount : 0}</sup>
  );
};

export default ShowCount;
